import { render } from "./UploadImg.vue?vue&type=template&id=d553152e&scoped=true"
import script from "./UploadImg.vue?vue&type=script&lang=js"
export * from "./UploadImg.vue?vue&type=script&lang=js"

import "./UploadImg.vue?vue&type=style&index=0&id=d553152e&scoped=true&lang=scss"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d553152e"]])

export default __exports__